// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function penalty_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var engagement_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "engagement_type"), null));
    if (engagement_type.TAG === /* Ok */0) {
      var crn = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "crn"), null));
      if (crn.TAG === /* Ok */0) {
        var msisdn = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "msisdn"), null));
        if (msisdn.TAG === /* Ok */0) {
          var driver_name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "driver_name"), null));
          if (driver_name.TAG === /* Ok */0) {
            var date = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "date"), null));
            if (date.TAG === /* Ok */0) {
              var penalty_type = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "penalty_type"), null));
              if (penalty_type.TAG === /* Ok */0) {
                var amount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "amount"), null));
                if (amount.TAG === /* Ok */0) {
                  var applied_at = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "applied_at"), null));
                  if (applied_at.TAG === /* Ok */0) {
                    var applied_by = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "applied_by"), null));
                    if (applied_by.TAG === /* Ok */0) {
                      var is_waived_off = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_waived_off"), null));
                      if (is_waived_off.TAG === /* Ok */0) {
                        var category = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "category"), null));
                        if (category.TAG === /* Ok */0) {
                          var is_deleted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_deleted"), null));
                          if (is_deleted.TAG === /* Ok */0) {
                            var deleted_at = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "deleted_at"), null));
                            if (deleted_at.TAG === /* Ok */0) {
                              var deleted_by = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "deleted_by"), null));
                              if (deleted_by.TAG === /* Ok */0) {
                                var comment = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "comment"), null));
                                if (comment.TAG === /* Ok */0) {
                                  return {
                                          TAG: /* Ok */0,
                                          _0: {
                                            id: id._0,
                                            engagement_type: engagement_type._0,
                                            crn: crn._0,
                                            msisdn: msisdn._0,
                                            driver_name: driver_name._0,
                                            date: date._0,
                                            penalty_type: penalty_type._0,
                                            amount: amount._0,
                                            applied_at: applied_at._0,
                                            applied_by: applied_by._0,
                                            is_waived_off: is_waived_off._0,
                                            category: category._0,
                                            is_deleted: is_deleted._0,
                                            deleted_at: deleted_at._0,
                                            deleted_by: deleted_by._0,
                                            comment: comment._0
                                          }
                                        };
                                }
                                var e = comment._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".comment" + e.path,
                                          message: e.message,
                                          value: e.value
                                        }
                                      };
                              }
                              var e$1 = deleted_by._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".deleted_by" + e$1.path,
                                        message: e$1.message,
                                        value: e$1.value
                                      }
                                    };
                            }
                            var e$2 = deleted_at._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".deleted_at" + e$2.path,
                                      message: e$2.message,
                                      value: e$2.value
                                    }
                                  };
                          }
                          var e$3 = is_deleted._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".is_deleted" + e$3.path,
                                    message: e$3.message,
                                    value: e$3.value
                                  }
                                };
                        }
                        var e$4 = category._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".category" + e$4.path,
                                  message: e$4.message,
                                  value: e$4.value
                                }
                              };
                      }
                      var e$5 = is_waived_off._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".is_waived_off" + e$5.path,
                                message: e$5.message,
                                value: e$5.value
                              }
                            };
                    }
                    var e$6 = applied_by._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".applied_by" + e$6.path,
                              message: e$6.message,
                              value: e$6.value
                            }
                          };
                  }
                  var e$7 = applied_at._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".applied_at" + e$7.path,
                            message: e$7.message,
                            value: e$7.value
                          }
                        };
                }
                var e$8 = amount._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".amount" + e$8.path,
                          message: e$8.message,
                          value: e$8.value
                        }
                      };
              }
              var e$9 = penalty_type._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".penalty_type" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                      }
                    };
            }
            var e$10 = date._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".date" + e$10.path,
                      message: e$10.message,
                      value: e$10.value
                    }
                  };
          }
          var e$11 = driver_name._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".driver_name" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
        }
        var e$12 = msisdn._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".msisdn" + e$12.path,
                  message: e$12.message,
                  value: e$12.value
                }
              };
      }
      var e$13 = crn._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".crn" + e$13.path,
                message: e$13.message,
                value: e$13.value
              }
            };
    }
    var e$14 = engagement_type._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".engagement_type" + e$14.path,
              message: e$14.message,
              value: e$14.value
            }
          };
  }
  var e$15 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$15.path,
            message: e$15.message,
            value: e$15.value
          }
        };
}

function t_decode(v) {
  return Decco.listFromJson(penalty_decode, v);
}

export {
  penalty_decode ,
  t_decode ,
  
}
/* No side effect */
